import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const ValidIncidentsPerSex
 = () => {

    const monitorReport = false;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType ="SEXVICTIM" disaggregation = "sex"/>
        </>
    
  )
}

export default ValidIncidentsPerSex
